import { render } from "./SplitColumn.vue?vue&type=template&id=02e8bcbd&scoped=true"
import script from "./SplitColumn.vue?vue&type=script&lang=js"
export * from "./SplitColumn.vue?vue&type=script&lang=js"

import "./SplitColumn.vue?vue&type=style&index=0&id=02e8bcbd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02e8bcbd"

export default script